import { apiSlice } from 'store/slices/api/api-slice';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        personageDelete: builder.mutation({
            query: (id: string) => ({
                url: `/personage/personage/` + id,
                method: 'DELETE',
                header: {},
            }),
        }),
    }),
});

export const { usePersonageDeleteMutation } = importTradeDataApiSlice;
